export abstract class Plugin {
  id: number;
  placeholder: number;
  pluginType: string;
  position: number;

  constructor(id: number, placeholder: number, position: number, pluginType: string) {
    this.id = id;
    this.placeholder = placeholder;
    this.position = position;
    this.pluginType = pluginType;
  }
}

export class TextPlugin extends Plugin {
  body: string;

  constructor(id: number, placeholder: number, position: number, pluginType: string, body: string) {
    super(id, placeholder, position, pluginType);
    this.body = body;
  }
}

export class ImagePlugin extends Plugin {
  file: string;
  caption: string;
  altText: string;
  parent: number;

  constructor(id: number, placeholder: number, position: number, pluginType: string, file: string, caption: string, altText: string) {
    super(id, placeholder, position, pluginType);
    this.file = file;
    this.caption = caption;
    this.altText = altText;
  }
}

export class GroupImagesPlugin extends Plugin {
  childImages: ImagePlugin[] = [];
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/plugins.ts